import { useCallback, useState } from 'react'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

// Note that whenever we call usePageNav we are re-initialising it, adding our
// props to the default values. We are not adding our props to the existing
// values.
const usePageNav = (defaultState) => {
  const [nav, setNav] = useState(defaultState)

  const mergeNavWithDefaults = useCallback(
    (props = {}) => {
      setNav({ ...defaultState, ...props })
    },
    [defaultState]
  )

  return [nav, mergeNavWithDefaults]
}

export default usePageNav
